import React from 'react'

import "web_common/css/LimnTech.css"

interface PathImportSuccessProps {

}

const PathImportSuccess: React.FC<PathImportSuccessProps> = (props) => {
    return (
        <div className='limn-form-container'>
            <h2 className='limn-warning limn-header'> Path Import Failure </h2>
            <div className='limn-div-centered limn-bigfont'>
                <p className='limn-tiny-p'> A problem occurred trying to publish your imported path. If this problem persists, please contact the LimnTech team. </p>
            </div>
        </div>
    )
}

export default PathImportSuccess
